import { gql } from '@apollo/client';

export const REFRESH_USER_ACCESS_TOKEN = gql`
	mutation LoginUser($credentials: RefreshUserTokenDto!) {
		refreshUserAccessToken(credentials: $credentials) {
			access_token
		}
	}
`;
